module.exports = __webpack_public_path__ + "static/media/147.df35d3d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/147.jpg
// module id = 941
// module chunks = 0